import { Check } from 'lucide-react';
import { Card, CardContent } from './ui/Card';
import Shell from './ui/Shell';

interface CompletedScreenProps {
  candidateName?: string | null;
}

export default function CompletedScreen({ candidateName }: CompletedScreenProps) {
  return (
    <Shell centered maxWidth="narrow">
      <Card>
        <CardContent className="text-center">
          <div
            className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-billed-soft text-billed"
            aria-hidden="true"
          >
            <Check className="h-7 w-7" strokeWidth={2.5} />
          </div>
          <h1 className="mb-2 text-2xl font-semibold tracking-tight">
            Thank you{candidateName ? `, ${candidateName}` : ''}.
          </h1>
          <p className="mb-2 text-base text-foreground/80">
            Your interview has been recorded.
          </p>
          <p className="text-sm text-muted-foreground">
            Your recruiter will review the transcript and reach out with next steps.
            You can safely close this tab.
          </p>
        </CardContent>
      </Card>
    </Shell>
  );
}
